<template lang="pug">
  include ../../../../../pug/mixins/bem
  div
    +b.poll-text.P {{ _("Всесвітня Організація Охорони Здоров'я рекомендує виключно грудне вигодовування в перші 6 місяців життя. Перед введенням прикорму проконсультуйтесь з лікарем-педіатром.") }}
    
    +b.poll-btn--with_ma.BUTTON(
      href='',
      @click.prevent='next'
    ) {{ _('Далі') }}
</template>

<script>
export default {
  name: 'Moz',
  data() {
    return {

    }
  },
  methods: {
    next() {
      this.$emit('next', {
        current: "Products"
      })
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/js/shared/components/poll/steps/moz.vue